import Vue from 'vue'
import router from '@/router'
import { Message } from 'element-ui'

export const authEventBus = new Vue()

let isRedirecting = false

export function getLoginStorage() {
  try {
    const str = localStorage.getItem('muiuserinfo')
    if (!str) return null
    const data = JSON.parse(str)
    if (!data || !data.token || !data.userInfo || typeof data.userInfo !== 'object') {
      return null
    }
    return data
  } catch (e) {
    return null
  }
}

export function hasValidLoginStorage() {
  return getLoginStorage() !== null
}

export function clearInvalidLoginStorage() {
  if (localStorage.getItem('muiuserinfo') && !hasValidLoginStorage()) {
    clearLoginState()
  }
}

export function clearLoginState() {
  localStorage.removeItem('muiuserinfo')
  localStorage.removeItem('colorindex')
  localStorage.removeItem('infonum')
}

/**
 * 全局恢复为未登录状态（清缓存、重置 UI、回首页）
 */
export function resetToLoggedOutState(message) {
  if (isRedirecting) return
  isRedirecting = true

  clearLoginState()
  authEventBus.$emit('logout')

  if (message) {
    Message({
      message,
      type: 'warning',
      duration: 2500,
      offset: 200
    })
  }

  const path = router.currentRoute.path
  const finish = () => {
    setTimeout(() => { isRedirecting = false }, 800)
  }

  if (path === '/' || path === '/login') {
    finish()
    return
  }

  router.replace('/').catch(() => {}).finally(finish)
}

export function handleUnauthorized(message) {
  resetToLoggedOutState(message || '登录已过期，请重新登录')
}

export function handleIdleLogout() {
  if (!hasValidLoginStorage()) return
  resetToLoggedOutState('长时间未操作，请重新登录')
}
